import Typography from "@portal/components/atoms/v2/typography";
import { useState } from "react";
import { MainBox } from "../components/mainBox";
import { UserMessageComponent } from "../components/message/UserMessageComponent";
import { RiskInfo, RiskOptions } from "./components";
import { IPageProps } from "@portal/types/robot/IPageProps";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { ToggleButton } from "@portal/components/atoms/buttons/toggle/ToggleButton";
import { useAppDispatch, useAppSelector } from "@portal/redux/store";
import { setRiskAppetite } from "@portal/redux/reducers/riskLevelReducer";
import { MapRiskAppetiteToIndex, MapIndexToRiskAppetite } from "../components/helpers/MapRiskAppetite";
import { RobotFooterComponent } from "../components/footer";
import { TextLine } from "@portal/components/atoms/v2/textLine";
import Link from "next/link";
import { useRouter } from "next/navigation";

export const RiskPage = ({ centerId, pageIndex, isDefaultLanguage }: IPageProps) => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const { request } = useAppSelector(state => state.persisted.riskLevel);
  const [showUserMessage, setShowUserMessage] = useState(false);
  const [toggleBoxOpen, setToggleBoxOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState<number | null>(MapRiskAppetiteToIndex(request.riskAppetite));
  const isButtonDisabled = request.riskAppetite === null || selectedOption === null || selectedOption === 0;

  const [shortHorizonUserMessage, setShortHorizonUserMessage] = useState(false);

  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const options = [texts.PAGE_5_A_1, texts.PAGE_5_B_1, texts.PAGE_5_C_1, texts.PAGE_5_D_1];
  const optionsHeaders = [texts.PAGE_5_A, texts.PAGE_5_B, texts.PAGE_5_C, texts.PAGE_5_D];

  const OnSelectionClick = (selectedOption: number) => {
    if (request.savingPeriod === 0 && selectedOption === 3) {
      setShortHorizonUserMessage(true);
    }
    if (selectedOption === 0) {
      setShowUserMessage(true);
      return;
    }
    setSelectedOption(selectedOption);
    const riskAppetite = MapIndexToRiskAppetite(selectedOption);
    if (riskAppetite !== null) dispatch(setRiskAppetite(riskAppetite));
  };

  return (
    <>
      <MainBox>
        <div className="flex mb-1.5">
          <Typography variant="Body">{texts.PAGE_5_INFO_HEADER}</Typography>
        </div>
        <Link prefetch={false} href="https://vff.no/fondshandboken" target="_blank" className="flex underline items-start">
          <Typography variant="Body">{texts.PAGE_5_HEADER_LINK}</Typography>
        </Link>
        <div className="flex mt-2 mb-0.5">
          <Typography variant="H6">{texts.PAGE_5_SUBHEADER}</Typography>
        </div>
        <TextLine />
        <RiskOptions
          optionsHeaders={optionsHeaders}
          optionsTexts={options}
          selectedItem={selectedOption}
          onSelectionClick={OnSelectionClick}
        />
        <ToggleButton
          activeText={texts.PAGE_5_TOGGLE}
          inActiveText={texts.TEXT_CLOSE}
          expanded={toggleBoxOpen}
          setExpanded={setToggleBoxOpen}
        />
        {toggleBoxOpen && <RiskInfo texts={[texts.PAGE_5_INFO_TEXT_A, texts.PAGE_5_INFO_TEXT_B, texts.PAGE_5_INFO_TEXT_C]} />}
      </MainBox>

      {showUserMessage && (
        <UserMessageComponent
          userMessage={texts.MESSAGE_NO_FUND_FOR_YOU}
          showDialog={showUserMessage}
          secondaryButtonText={texts.MESSAGE_CHANGE_REPLY}
          secondaryButtonClick={() => {
            setShowUserMessage(false);
          }}
        />
      )}
      {shortHorizonUserMessage && (
        <UserMessageComponent
          content={
            <div>
              <Typography variant="BodySpan">{texts.SHORT_HORIZON_USER_MESSAGE}</Typography>
              <Link href={`/robot/3?centerId=${centerId}`} className="text-blueHighlighted">
                her
              </Link>
            </div>
          }
          showDialog={shortHorizonUserMessage}
          primaryButtonText={texts.SHORT_HORIZON_CONTINUE}
          primaryButtonClick={() => {
            setShortHorizonUserMessage(false);
          }}
          secondaryButtonText={texts.SHORT_HORIZON_GO_BACK}
          secondaryButtonClick={() => {
            setSelectedOption(null);
            dispatch(setRiskAppetite(null));
            setShortHorizonUserMessage(false);

            router.push(`/robot/4?centerId=${centerId}`);
          }}
        />
      )}
      <RobotFooterComponent
        pageIndex={pageIndex}
        centerId={centerId}
        primaryButtonText={texts.BUTTON_NEXT}
        secondaryButtonText={texts.BUTTON_BACK}
        disabled={isButtonDisabled}
      />
    </>
  );
};
